/* ================================================== */
/* FANCYBOX → Gallery
/* ================================================== */

$(document).ready(function() {

	$('[data-fancybox="gallery"]').fancybox({
		buttons : [
			'close'
		]
	});

});